// ** MUI Import
import Box from '@mui/material/Box';
import { SxProps, useTheme } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';

type Props = {
    sx?: SxProps;
    text?: string;
};

const LoadingSpinner = ({ sx, text }: Props) => {
    // ** Hook
    const theme = useTheme();

    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                ...sx,
            }}
        >
            <svg
                width={82}
                height={68}
                version="1.1"
                viewBox="0 0 30 23"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <polygon
                            points="0,0.663 9.401,0.663 15.882,7.146 15.882,14.127 5.307,3.608 5.274,22.969 0,22.969 		"
                            fill={theme.palette.primary.main}
                        />
                        <polygon
                            points="23.631,22.969 14.232,22.969 7.752,16.485 7.752,9.501 18.327,20.018 18.359,0.662 23.631,0.662 		"
                            fill={theme.palette.primary.main}
                        />
                    </g>
                </g>
            </svg>
            <CircularProgress disableShrink sx={{ mt: 6, mb: 6 }} title={text} />
            {text}
        </Box>
    );
};

export default LoadingSpinner;
